<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div v-if="setting_type_food == 0">
        <div v-for="(alacarte_detail, key) in alacarte_list" :key="key">
          <v-card class="mb-5" v-if="alacarte_detail.menuList.length > 0">
            <h3 class="pa-3">
              {{ alacarte_detail.name }}
            </h3>
            <div
              v-for="(food_detail, key_detail) in alacarte_detail.menuList"
              :key="key_detail"
            >
              <div class="mb-2 pa-3" v-if="food_detail.status == 1">
                <div
                  class="cursor_type_alacarte"
                  @click="openDetail(food_detail.id)"
                >
                  <div class="d-flex justify-space-between">
                    <div
                      class="d-flex flex-column justify-space-between size_title_type_alacarte"
                    >
                      <div>
                        <div>
                          {{ food_detail.name }}
                          <span class="description_type_alacarte"
                            >( {{ food_detail.nameEng }} )</span
                          >
                        </div>
                        <div class="description_type_alacarte">
                          {{ food_detail.sub_title }}
                        </div>
                      </div>

                      <div>
                        {{ Intl.NumberFormat().format(food_detail.price) }} ฿
                      </div>
                    </div>
                    <div class="img_type_alacarte">
                      <img :src="food_detail.picture" />
                    </div>
                  </div>
                </div>
                <v-divider
                  v-if="
                    key_detail !=
                    Object.keys(alacarte_detail.menuList).length - 1
                  "
                ></v-divider>
              </div>
              <div
                class="mb-2 pa-3"
                style="background: #eee"
                v-if="food_detail.status == 0"
              >
                <div class="cursor_type_alacarte">
                  <div class="d-flex justify-space-between">
                    <div
                      class="d-flex flex-column justify-space-between size_title_type_alacarte"
                    >
                      <div>
                        <h4 class="itemout_type_alacarte">ขออภัยสินค้าหมด</h4>
                        <div>
                          {{ food_detail.name }}
                          <span class="description_type_alacarte"
                            >( {{ food_detail.nameEng }} )</span
                          >
                        </div>
                        <div class="description_type_alacarte">
                          {{ food_detail.sub_title }}
                        </div>
                      </div>
                      <div>
                        {{ Intl.NumberFormat().format(food_detail.price) }} ฿
                      </div>
                    </div>
                    <div class="img_type_alacarte">
                      <img :src="food_detail.picture" />
                      <div class="img_sole_type_alacarte">
                        <img src="@/assets/soulout.png" />
                      </div>
                    </div>
                  </div>
                </div>
                <v-divider
                  v-if="
                    key_detail !=
                    Object.keys(alacarte_detail.menuList).length - 1
                  "
                ></v-divider>
              </div>
            </div>
          </v-card>
        </div>
      </div>
      <div v-if="setting_type_food == 1">
        <v-container v-if="!alacarte_id">
          <v-row>
            <!-- <v-col cols="12">
                        <v-text-field label="ค้นหาเมนูอาหาร" v-model="search" @keyup="searchMenu()" :color="border_color" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="!search"> -->
            <v-col
              cols="6"
              v-for="(alacarte_detail, key_food) in alacarte_list"
              :key="key_food"
            >
              <div
                class="cursor_type_alacarte"
                @click="alacarteSelectPage(alacarte_detail.id)"
              >
                <div class="cover_image_type_alacarte">
                  <img :src="alacarte_detail.cover_image" />
                </div>
                <div class="text-center">{{ alacarte_detail.name }}</div>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <div v-if="search">
          <v-card class="mb-5">
            <div
              v-for="(
                food_search_detail, key_search_detail
              ) in alacarte_search_list"
              :key="key_search_detail"
            >
              <div class="mb-2 pa-3" v-if="food_search_detail.status == 1">
                <div
                  class="cursor_type_alacarte"
                  @click="openDetail(food_search_detail.id)"
                >
                  <div class="d-flex justify-space-between">
                    <div
                      class="d-flex flex-column justify-space-between size_title_type_alacarte"
                    >
                      <div>
                        <div>
                          {{ food_search_detail.name }}
                          <span class="description_type_alacarte"
                            >( {{ food_search_detail.nameEng }} )</span
                          >
                        </div>
                        <div class="description_type_alacarte">
                          {{ food_search_detail.sub_title }}
                        </div>
                      </div>
                      <div>
                        {{
                          Intl.NumberFormat().format(food_search_detail.price)
                        }}
                        ฿
                      </div>
                    </div>
                    <div class="img_type_alacarte">
                      <img :src="food_search_detail.picture" />
                    </div>
                  </div>
                </div>
                <v-divider
                  v-if="
                    key_search_detail !=
                    Object.keys(alacarte_search_list).length - 1
                  "
                ></v-divider>
              </div>
              <div
                class="mb-2 pa-3"
                style="background: #eee"
                v-if="food_search_detail.status == 0"
              >
                <div class="cursor_type_alacarte">
                  <div class="d-flex justify-space-between">
                    <div
                      class="d-flex flex-column justify-space-between size_title_type_alacarte"
                    >
                      <div>
                        <h4 class="itemout_type_alacarte">ขออภัยสินค้าหมด</h4>
                        <div>
                          {{ food_search_detail.name }}
                          <span class="description_type_alacarte"
                            >( {{ food_search_detail.nameEng }} )</span
                          >
                        </div>
                        <div class="description_type_alacarte">
                          {{ food_search_detail.sub_title }}
                        </div>
                      </div>
                      <div>
                        {{
                          Intl.NumberFormat().format(food_search_detail.price)
                        }}
                        ฿
                      </div>
                    </div>
                    <div class="img_type_alacarte">
                      <img :src="food_search_detail.picture" />
                      <div class="img_sole_type_alacarte">
                        <img src="@/assets/soulout.png" />
                      </div>
                    </div>
                  </div>
                </div>
                <v-divider
                  v-if="
                    key_search_detail !=
                    Object.keys(alacarte_search_list).length - 1
                  "
                ></v-divider>
              </div>
            </div>
          </v-card>
        </div>
        <div class="px-1 mb-2 d-flex align-center" v-if="alacarte_id">
          <div
            class="d-flex align-center cursor_type_alacarte"
            @click="alacarteSelectBackPage()"
          >
            <v-icon size="30">mdi-arrow-left-bold-circle</v-icon>
            <div class="ml-1">ย้อนกลับ</div>
          </div>
        </div>
        <div v-if="alacarte_id">
          <v-card class="mb-5" v-if="alacarte_select_list.menuList.length > 0">
            <h3 class="pa-3 text-center">
              {{ alacarte_select_list.name }}
            </h3>
            <div
              v-for="(
                food_select_detail, key_detail
              ) in alacarte_select_list.menuList"
              :key="key_detail"
            >
              <div class="mb-2 pa-3" v-if="food_select_detail.status == 1">
                <div
                  class="cursor_type_alacarte"
                  @click="openDetail(food_select_detail.id)"
                >
                  <div class="d-flex justify-space-between">
                    <div
                      class="d-flex flex-column justify-space-between size_title_type_alacarte"
                    >
                      <div>
                        <div>
                          {{ food_select_detail.name }}
                          <span class="description_type_alacarte"
                            >( {{ food_select_detail.nameEng }} )</span
                          >
                        </div>
                        <div class="description_type_alacarte">
                          {{ food_select_detail.sub_title }}
                        </div>
                      </div>
                      <div>
                        {{
                          Intl.NumberFormat().format(food_select_detail.price)
                        }}
                        ฿
                      </div>
                    </div>
                    <div class="img_type_alacarte">
                      <img :src="food_select_detail.picture" />
                    </div>
                  </div>
                </div>
                <v-divider
                  v-if="
                    key_detail !=
                    Object.keys(alacarte_select_list.menuList).length - 1
                  "
                ></v-divider>
              </div>
              <div
                class="mb-2 pa-3"
                style="background: #eee"
                v-if="food_select_detail.status == 0"
              >
                <div class="cursor_type_alacarte">
                  <div class="d-flex justify-space-between">
                    <div
                      class="d-flex flex-column justify-space-between size_title_type_alacarte"
                    >
                      <div>
                        <h4 class="itemout_type_alacarte">ขออภัยสินค้าหมด</h4>
                        <div>
                          {{ food_select_detail.name }}
                          <span class="description_type_alacarte"
                            >( {{ food_select_detail.nameEng }} )</span
                          >
                        </div>
                        <div class="description_type_alacarte">
                          {{ food_select_detail.sub_title }}
                        </div>
                      </div>
                      <div>
                        {{
                          Intl.NumberFormat().format(food_select_detail.price)
                        }}
                        ฿
                      </div>
                    </div>
                    <div class="img_type_alacarte">
                      <img :src="food_select_detail.picture" />
                      <div class="img_sole_type_alacarte">
                        <img src="@/assets/soulout.png" />
                      </div>
                    </div>
                  </div>
                </div>
                <v-divider
                  v-if="
                    key_detail !=
                    Object.keys(alacarte_select_list.menuList).length - 1
                  "
                ></v-divider>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <AddToppingMenu />
  </div>
</template>

<script>
import { HTTP } from "@/axios.js";
import before_image from "@/assets/fast-food.png";
import AddToppingMenu from "@/components/menuuser/addmenu/AddToppingMenu.vue";
export default {
  components: {
    AddToppingMenu,
  },
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  data() {
    return {
      loading_page: true,
      border_color: "#038cc1",
      food_image: before_image,
      search: "",
      alacarte_list: [],
      alacarte_id: null,
      alacarte_select_list: [],
      alacarte_search_default_list: [],
      alacarte_search_list: [],
      setting_type_food: 0,
    };
  },
  methods: {
    async searchMenu() {
      this.alacarte_search_list = this.alacarte_search_default_list.filter(
        (detail) => detail.name.toLowerCase().indexOf(this.search) > -1
      );
    },
    async alacarteList() {
      this.alacarte_list = [];
      this.alacarte_search_default_list = [];
      this.alacarte_search_list = [];
      if (
        this.$route.name == "buffetUser" ||
        this.$route.name == "singleDishMealUser"
      ) {
        let typeFoodUser = "บุฟเฟ่";
        if (this.$route.name == "singleDishMealUser") {
          typeFoodUser = "ไม่บุฟเฟ่";
        }

        HTTP.get(`/customer/alacarte-menu-list?type=` + typeFoodUser + `&store_id=${this.$route.params.store_id}&token=`+this.$route.params.token, {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        })
          .then((response) => {
            if (response.data.successful === true) {
              response.data.listCarte.forEach((detail) => {
                if (detail.menuList.length > 0) {
                  let image_item = detail.menuList[0];
                  this.alacarte_list.push({
                    id: detail.id,
                    cover_image: !image_item.picture ? this.food_image : image_item.picture,
                    name: detail.name,
                    menuList: detail.menuList,
                  });
                  this.alacarte_search_default_list.push(detail.menuList);
                }
              });
              this.alacarte_search_default_list =
                this.alacarte_search_default_list.flat();
              this.loading_page = false;
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit("logOutSuccess");
              this.$router.push("/login");
            }
          });
      }
      if (
        this.$route.name == "takeOutUser" ||
        this.$route.name == "takeOutUserTable" ||
        this.$route.name == "orderOnlinePickUp"
      ) {
        HTTP.get(`/customer/alacarte-menu-buyback-list` + `?store_id=${this.$route.params.store_id}&token=`+this.$route.params.token, {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        })
          .then((response) => {
            if (response.data.successful === true) {
              response.data.listCarte.forEach((detail) => {
                if (detail.menuList.length > 0) {
                  let image_item = detail.menuList[0];
                  this.alacarte_list.push({
                    id: detail.id,
                    cover_image: !image_item.picture ? this.food_image : image_item.picture,
                    name: detail.name,
                    menuList: detail.menuList,
                  });
                  this.alacarte_search_default_list.push(detail.menuList);
                }
              });
              this.alacarte_search_default_list =
                this.alacarte_search_default_list.flat();
              this.loading_page = false;
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit("logOutSuccess");
              this.$router.push("/login");
            }
          });
      }
    },
    async openDetail(id) {
      const dataList = {
        id: id,
        type: 1,
      };
      this.$root.$emit("getDetail", dataList);
    },
    async alacarteSelectPage(id) {
      this.alacarte_id = id;
      this.alacarte_select_list = this.alacarte_list.find(
        (detail) => detail.id == this.alacarte_id
      );
    },
    async alacarteSelectBackPage() {
      this.alacarte_id = null;
      this.alacarte_select_list = [];
    },
  },
  created() {
    HTTP.get(`/showColor?store_id=${this.$route.params.store_id}&token=`+this.$route.params.token)
      .then((response) => {
        if (response.data.successful === true) {
          this.border_color = response.data.color_code;
          this.setting_type_food = response.data.setting_type_food;
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit("logOutSuccess");
          this.$router.push("/login");
        }
        if (error.response.status === 500) {
          // this.$router.push("/nametakeoutuser");
        }
      });
  },
  mounted() {
    this.alacarteList();
  },
};
</script>

<style scoped>
.cursor_type_alacarte {
  cursor: pointer;
}

.cover_image_type_alacarte {
  display: flex;
  justify-content: center;
  height: 130px;
  width: 100%;
  border-radius: 20%;
  overflow: hidden;
  position: relative;
}

.cover_image_type_alacarte > img {
  max-width: 100%;
}

.size_title_type_alacarte {
  font-size: 18px;
  width: 50%;
}

.description_type_alacarte {
  font-size: 14px;
  color: #696969;
}

.img_type_alacarte {
  position: relative;
  width: 150px;
}

.img_type_alacarte > img {
  max-width: 100%;
}

.itemout_type_alacarte {
  color: red;
}

.img_sole_type_alacarte {
  width: 85px;
  position: absolute;
  top: 0;
}

.img_sole_type_alacarte > img {
  max-width: 100%;
}
</style>
